export const entitiesName = {
  LEAD: 'LEAD',
  ACCOUNT: 'ACCOUNT',
  CONTACT: 'CONTACT',
  OPPORTUNITY: 'OPPORTUNITY',
  PROTOCOL: 'PROTOCOL'
};
